import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-dialog-notification-footer',
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'app-dialog-notification__footer',
  },
})
export class DialogNotificationFooterComponent {
  constructor() {}
}
